(function () {
  'use strict';

  var PDP_SEL = '[data-dd-discount-pill]';
  var FOOTER_SEL = '[data-dd-discount-pill-footer]';
  var SALE_PILL_SEL = '[data-dd-sale-pill]';
  var PDP_PRO_SALE_SEL = '[data-dd-pdp-pro-sale]';
  var PDP_MSRP_WRAP_SEL = '[data-dd-pdp-msrp-wrap]';
  var PDP_MSRP_SEL = '[data-dd-pdp-msrp]';
  var SHIPPING_PILL_SEL = '[data-dd-shipping-pill]';
  var SHIMMER_CLASS = 'dd-discount-pill--shimmer';
  var REGIOS_TIMEOUT = 8000;
  var _currentVariant = null;
  var _discount = null;
  var _regiosDiscount = null;
  var _regiosApi = null;
  var _regiosGlobalApi = null;
  var _lastApiVid = null;
  var _lastApiFailed = {};
  var _regiosNoDiscountRetries = {};
  var _regiosRetryTimers = {};
  var _fallbackTimer = null;
  var _tiers = [];
  var MAX_NO_DISCOUNT_RETRIES = 3;

  function processVariant(variant) {
    _currentVariant = variant || null;

    if (!variant) {
      setUnavailable();
      return;
    }

    var vid = String(variant.id);

    var prevDiscount = _discount;
    _discount = null;

    applyTierBaseline();
    tryCompareAtPrice(variant);

    if (_regiosDiscount && _regiosDiscount.variantId === vid) {
      _discount = _regiosDiscount;
    } else if (variant.available === false && _regiosDiscount && _regiosDiscount.pct) {
      _discount = {
        pct: _regiosDiscount.pct,
        name: _regiosDiscount.name || '',
        note: _regiosDiscount.note || '',
        variantId: vid,
      };
    }

    if (_discount) {
      renderCurrentDiscount();
    } else if (prevDiscount && prevDiscount.variantId === vid) {
      _discount = prevDiscount;
      renderCurrentDiscount();
    } else {
      hideDiscount();
    }

    if (_lastApiFailed[vid]) {
      delete _lastApiFailed[vid];
      _lastApiVid = null;
    }

    tryRegiosApiForVariant(variant);

    clearTimeout(_fallbackTimer);
    _fallbackTimer = setTimeout(function () {
      if (!_currentVariant || String(_currentVariant.id) !== vid) return;
      if (_discount) {
        renderCurrentDiscount();
      }
    }, REGIOS_TIMEOUT);

    syncShippingPillVisibility();
  }

  // Hide the PDP "Qualifies for free 2-day shipping" pill whenever the
  // effective per-unit price (Regios sale price if present, else gross
  // variant.price) drops below the threshold encoded on the pill itself.
  // Liquid renders the initial state from gross price; this keeps it
  // honest after Regios resolves and on every variant change.
  function syncShippingPillVisibility() {
    var pills = document.querySelectorAll(SHIPPING_PILL_SEL);
    if (!pills.length) return;

    var effectiveCents = null;
    if (_regiosDiscount && _currentVariant &&
        _regiosDiscount.variantId === String(_currentVariant.id) &&
        typeof _regiosDiscount.saleAmount === 'number') {
      effectiveCents = Math.round(_regiosDiscount.saleAmount * 100);
    } else if (_currentVariant && typeof _currentVariant.price === 'number') {
      effectiveCents = _currentVariant.price;
    }

    pills.forEach(function (pill) {
      var threshold = parseInt(pill.getAttribute('data-threshold') || '0', 10);
      if (!threshold || effectiveCents == null) return;
      if (effectiveCents >= threshold) {
        pill.removeAttribute('hidden');
      } else {
        pill.setAttribute('hidden', '');
      }
    });
  }

  function init() {
    var tierEl = document.querySelector(PDP_SEL);
    if (tierEl) {
      try { _tiers = JSON.parse(tierEl.getAttribute('data-discount-tiers') || '[]'); } catch (e) {}
    }

    if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        var variant = event && event.data ? event.data.variant : null;
        processVariant(variant);
        updateMsrpDisplay(variant);
      });
    }

    listenForRegiosApi();
    pollRegiosApi();
    bindStickyQuantitySync();

    var scriptEl = document.querySelector('variant-selects script[data-selected-variant]');
    if (scriptEl) {
      try {
        var v = JSON.parse(scriptEl.textContent);
        if (v && v.id) {
          processVariant(v);
          updateMsrpDisplay(v);
        }
      } catch (e) {}
    }
  }

  function pollRegiosApi() {
    var attempts = 0;
    var maxAttempts = 60;
    var timer = setInterval(function () {
      attempts += 1;
      var apiV0 = window.RegiosDOPP && window.RegiosDOPP.api && window.RegiosDOPP.api.v0;
      var api = apiV0 && apiV0.productPage;
      if (api) {
        clearInterval(timer);
        setRegiosApi(apiV0);
      } else if (attempts >= maxAttempts) {
        clearInterval(timer);
      }
    }, 500);
  }

  function listenForRegiosApi() {
    window.addEventListener('regios-dopp:api-initialized', function (event) {
      var api = event && event.detail && event.detail.api;
      if (api && api.productPage) setRegiosApi(api);
    });
  }

  function setRegiosApi(apiV0) {
    if (!apiV0 || !apiV0.productPage) return;
    _regiosGlobalApi = apiV0;
    _regiosApi = apiV0.productPage;
    if (_currentVariant) {
      _lastApiVid = null;
      tryRegiosApiForVariant(_currentVariant);
    }
  }

  function applyTierBaseline() {
    for (var i = 0; i < _tiers.length; i++) {
      if (_tiers[i].pct > (_discount ? _discount.pct : 0)) {
        _discount = {
          pct: _tiers[i].pct,
          name: _tiers[i].name || '',
          note: _tiers[i].note || '',
        };
      }
    }
  }

  function tryCompareAtPrice(variant) {
    if (!variant || !variant.compare_at_price || variant.compare_at_price <= variant.price) return false;
    var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
    if (pct > (_discount ? _discount.pct : 0)) {
      _discount = { pct: pct, name: '', note: '' };
    }
    return true;
  }

  function clearRegiosRetryTimer(vid) {
    if (!vid || !_regiosRetryTimers[vid]) return;
    clearTimeout(_regiosRetryTimers[vid]);
    delete _regiosRetryTimers[vid];
  }

  function scheduleNoDiscountRetry(variant, vid) {
    if (!variant || String(variant.id) !== vid) return;
    if (variant.available === false) return;
    if (variant.compare_at_price && variant.compare_at_price > variant.price) return;

    var attempts = _regiosNoDiscountRetries[vid] || 0;
    if (attempts >= MAX_NO_DISCOUNT_RETRIES) return;

    _regiosNoDiscountRetries[vid] = attempts + 1;
    clearRegiosRetryTimer(vid);

    var delay = attempts === 0 ? 1200 : attempts === 1 ? 2500 : 5000;
    _regiosRetryTimers[vid] = setTimeout(function () {
      delete _regiosRetryTimers[vid];
      if (!_currentVariant || String(_currentVariant.id) !== vid) return;
      _lastApiVid = null;
      tryRegiosApiForVariant(_currentVariant);
    }, delay);
  }

  function tryRegiosApiForVariant(variant) {
    if (!_regiosApi || !variant || !variant.id) return;
    var vid = String(variant.id);
    if (vid === _lastApiVid) return;
    _lastApiVid = vid;

    var qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

    calculateRegiosDiscount(variant, qty)
      .then(function (result) {
        if (!_currentVariant || String(_currentVariant.id) !== vid) return;
        applyRegiosResult(result, variant, vid);
      })
      .catch(function (err) {
        console.warn('[dd-discount-pill] Regios API error for variant', vid, err);
        if (isUnavailableVariantError(err)) {
          retryRegiosWithGlobalApi(variant, qty, vid);
          return;
        }
        _lastApiFailed[vid] = true;
        _lastApiVid = null;
        syncShippingPillVisibility();
      });
  }

  function applyRegiosResult(result, variant, vid) {
    if (!_currentVariant || String(_currentVariant.id) !== vid) return false;
    if (!result || !result.salePrice || !result.regularPrice) {
      console.warn('[dd-discount-pill] Regios returned invalid data for variant', vid, result);
      scheduleNoDiscountRetry(variant, vid);
      return false;
    }
    if (result.salePrice.amount >= result.regularPrice.amount) {
      scheduleNoDiscountRetry(variant, vid);
      return false;
    }

    var pct = Math.round((result.regularPrice.amount - result.salePrice.amount) / result.regularPrice.amount * 100);
    var name = result.discountMessage || (result.description && result.description.html) || '';
    if (pct <= 0) return false;

    var newDiscount = {
      pct: pct,
      name: name,
      note: '',
      saleAmount: result.salePrice.amount,
      compareAmount: result.regularPrice.amount,
      variantId: vid,
    };

    _regiosDiscount = newDiscount;
    _regiosNoDiscountRetries[vid] = 0;
    clearRegiosRetryTimer(vid);

    if (!_discount || pct >= _discount.pct) {
      _discount = newDiscount;
      renderCurrentDiscount();
    }

    syncShippingPillVisibility();
    return true;
  }

  function calculateRegiosDiscount(variant, qty) {
    var payload = { variantId: parseInt(variant.id, 10), quantity: qty };
    if (variant.available === false && _regiosGlobalApi && typeof _regiosGlobalApi.calculateDiscountedPrices === 'function') {
      return _regiosGlobalApi.calculateDiscountedPrices(buildGlobalRegiosPayload(variant, qty));
    }
    return _regiosApi.calculateDiscountedPrices(payload);
  }

  function buildGlobalRegiosPayload(variant, qty) {
    var productInfo = document.querySelector('product-info[data-product-id]');
    var payload = {
      variantId: parseInt(variant.id, 10),
      quantity: qty,
      regularPriceInCents: Number(variant.price),
    };
    if (productInfo) {
      payload.productId = parseInt(productInfo.getAttribute('data-product-id'), 10);
      if (productInfo.getAttribute('data-url')) payload.url = productInfo.getAttribute('data-url');
    }
    if (variant.compare_at_price) payload.compareAtPriceInCents = Number(variant.compare_at_price);
    return payload;
  }

  function retryRegiosWithGlobalApi(variant, qty, vid) {
    if (!_regiosGlobalApi || typeof _regiosGlobalApi.calculateDiscountedPrices !== 'function') {
      _lastApiFailed[vid] = true;
      clearRegiosRetryTimer(vid);
      renderUnavailableVariantFromKnownDiscount(variant, vid);
      return;
    }

    _regiosGlobalApi.calculateDiscountedPrices(buildGlobalRegiosPayload(variant, qty))
      .then(function (result) {
        if (!applyRegiosResult(result, variant, vid)) {
          renderUnavailableVariantFromKnownDiscount(variant, vid);
        }
      })
      .catch(function (err) {
        console.warn('[dd-discount-pill] Regios global API error for variant', vid, err);
        _lastApiFailed[vid] = true;
        clearRegiosRetryTimer(vid);
        renderUnavailableVariantFromKnownDiscount(variant, vid);
      });
  }

  function renderUnavailableVariantFromKnownDiscount(variant, vid) {
    if (!variant || String(variant.id) !== vid || !_regiosDiscount || !_regiosDiscount.pct) return;
    _discount = {
      pct: _regiosDiscount.pct,
      name: _regiosDiscount.name || '',
      note: _regiosDiscount.note || '',
      variantId: vid,
    };
    renderCurrentDiscount();
    syncShippingPillVisibility();
  }

  function isUnavailableVariantError(err) {
    if (!err) return false;
    var message = String(err.message || err);
    var code = String(err.code || err.type || err.name || '');
    return /selected variant is not available/i.test(message) ||
      (/USER_ERROR/i.test(code) && /variant/i.test(message) && /available/i.test(message));
  }

  function renderCurrentDiscount() {
    if (!_currentVariant || !_discount || !_discount.pct) {
      hideDiscount();
      return;
    }

    var variant = _currentVariant;
    var saleAmount;
    var compareAmount;

    if (_discount.saleAmount != null && _discount.compareAmount != null &&
        _discount.variantId === String(variant.id)) {
      saleAmount = _discount.saleAmount;
      compareAmount = _discount.compareAmount;
    } else if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      saleAmount = variant.price / 100;
      compareAmount = variant.compare_at_price / 100;
    } else {
      compareAmount = variant.price / 100;
      saleAmount = compareAmount * (1 - _discount.pct / 100);
    }

    var label = ((_discount.name ? _discount.name + ' ' : '') + _discount.pct + '% OFF').trim().toUpperCase();
    var footerLabel = (_discount.name || '').trim().toUpperCase();
    var fmt = window.shopMoneyFormat || '${{amount}}';
    var saleText = formatMoney(Math.round(saleAmount * 100), fmt);
    var compareText = formatMoney(Math.round(compareAmount * 100), fmt);

    document.querySelectorAll(PDP_SEL + ', ' + FOOTER_SEL).forEach(function (el) {
      el.classList.remove(SHIMMER_CLASS);
      var saleEl = el.querySelector('[data-dd-pill-sale]');
      var compareEl = el.querySelector('[data-dd-pill-compare]');
      var textEl = el.querySelector('[data-dd-pill-text]');
      var copyEl = el.querySelector('[data-dd-pill-copy]');
      var isFooter = el.matches(FOOTER_SEL);
      var displayQty = isFooter ? getStickyFooterQuantity(el) : 1;
      var displaySaleText = formatMoney(Math.round(saleAmount * displayQty * 100), fmt);
      var displayCompareText = formatMoney(Math.round(compareAmount * displayQty * 100), fmt);

      if (saleEl) saleEl.textContent = displaySaleText;
      if (compareEl) {
        compareEl.textContent = displayCompareText;
        compareEl.style.display = compareAmount > saleAmount ? '' : 'none';
      }
      if (textEl) textEl.textContent = isFooter ? footerLabel : label;
      if (copyEl) {
        if (_discount.name) {
          copyEl.style.display = '';
          copyEl.setAttribute('data-code', _discount.name);
        } else {
          copyEl.style.display = 'none';
        }
      }
      el.style.display = '';
      toggleSiblingPrice(el, true);
    });

    document.querySelectorAll(SALE_PILL_SEL).forEach(function (wrap) {
      wrap.innerHTML =
        '<div class="dd-discount-pill-banner">' +
          '<span class="dd-discount-pill-banner__text" data-dd-pill-text></span>' +
        '</div>';
      var bannerText = wrap.querySelector('[data-dd-pill-text]');
      if (bannerText) bannerText.textContent = label;
    });

    updatePdpProPriceRow(saleText, compareText, compareAmount > saleAmount);

    var atcPrice = document.querySelector('[data-dd-atc-price]');
    if (atcPrice) {
      atcPrice.innerHTML =
        (compareAmount > saleAmount ? '<span class="dd-atc-button__compare">' + compareText + '</span>' : '') +
        '<span class="dd-atc-button__current">' + saleText + '</span>';
    }
  }

  function updatePdpProPriceRow(saleText, compareText, showMsrp) {
    document.querySelectorAll(PDP_PRO_SALE_SEL).forEach(function (el) {
      el.textContent = saleText;
      el.classList.toggle('dd-pro-price__sale--discounted', !!showMsrp);
    });
    document.querySelectorAll(PDP_MSRP_WRAP_SEL).forEach(function (wrap) {
      var msrp = wrap.querySelector(PDP_MSRP_SEL);
      if (!msrp) return;
      if (showMsrp) {
        msrp.textContent = compareText;
        wrap.style.display = '';
      } else {
        msrp.textContent = '';
        wrap.style.display = 'none';
      }
    });
  }

  function getStickyFooterQuantity(discountEl) {
    var sticky = discountEl && discountEl.closest ? discountEl.closest('dd-sticky-footer') : null;
    var qtyText = sticky ? sticky.querySelector('[data-dd-sf-qty-value]') : null;
    var qty = qtyText ? parseInt(qtyText.textContent || '1', 10) : 1;
    if (!isFinite(qty) || qty < 1) {
      var qtyInput = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
      qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    }
    return qty;
  }

  function scheduleFooterDiscountRender() {
    if (!_currentVariant || !_discount || !_discount.pct) return;
    Promise.resolve().then(function () {
      if (!_currentVariant || !_discount || !_discount.pct) return;
      renderCurrentDiscount();
    });
  }

  function bindStickyQuantitySync() {
    document.addEventListener('click', function (event) {
      var target = event.target && event.target.closest
        ? event.target.closest('[data-dd-sf-qty-minus], [data-dd-sf-qty-plus], [data-dd-bundle-apply]')
        : null;
      if (!target) return;
      scheduleFooterDiscountRender();
    });

    document.addEventListener('input', function (event) {
      if (!event.target || !event.target.matches || !event.target.matches('form[action*="/cart/add"] input[name="quantity"]')) return;
      scheduleFooterDiscountRender();
    });

    document.addEventListener('change', function (event) {
      if (!event.target || !event.target.matches || !event.target.matches('form[action*="/cart/add"] input[name="quantity"]')) return;
      scheduleFooterDiscountRender();
    });
  }

  function resetPdpProPriceRowFromVariant(variant) {
    if (!variant) return;
    var fmt = window.shopMoneyFormat || '${{amount}}';
    var saleText = formatMoney(variant.price, fmt);
    var showCompare = variant.compare_at_price && variant.compare_at_price > variant.price;
    var compareText = showCompare ? formatMoney(variant.compare_at_price, fmt) : '';
    updatePdpProPriceRow(saleText, compareText, !!showCompare);
  }

  function toggleSiblingPrice(discountEl, pillActive) {
    if (!discountEl || !discountEl.parentNode) return;
    var parent = discountEl.parentNode;
    var target = parent.querySelector('[data-dd-sf-price-wrap]') ||
                 parent.querySelector('[data-dd-sf-price]');
    if (target) target.style.display = pillActive ? 'none' : '';
  }

  function updateMsrpDisplay(variant) {
    var map = window._ddMsrpMap;
    if (!map || !variant) return;
    var cents = map[String(variant.id)];
    if (!cents) return;
    var fmt = window.shopMoneyFormat ? String(window.shopMoneyFormat).replace(/<[^>]*>/g, '') : '${{amount}}';
    var formatted = formatMoney(cents, fmt);
    document.querySelectorAll('[data-dd-msrp]').forEach(function (el) {
      var prefix = el.getAttribute('data-dd-msrp-prefix') || '';
      el.textContent = prefix + formatted;
    });
  }

  function hideDiscount() {
    document.querySelectorAll(PDP_SEL + ', ' + FOOTER_SEL).forEach(function (el) {
      el.classList.remove(SHIMMER_CLASS);
      el.style.display = 'none';
      toggleSiblingPrice(el, false);
    });
    document.querySelectorAll(SALE_PILL_SEL).forEach(function (wrap) {
      wrap.innerHTML = '';
    });
    resetPdpProPriceRowFromVariant(_currentVariant);
    syncShippingPillVisibility();
  }

  function setUnavailable() {
    hideDiscount();
  }

  function showShimmer() {
    document.querySelectorAll(PDP_SEL + ', ' + FOOTER_SEL).forEach(function (el) {
      el.classList.add(SHIMMER_CLASS);
      el.style.display = '';
    });
  }

  function formatMoney(cents, fmt) {
    var amount = (cents / 100).toFixed(2);
    var amountWithCommas = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var out = fmt
      .replace(/\{\{\s*amount\s*\}\}/, amountWithCommas)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/<[^>]*>/g, '');
    if (out.indexOf('hide-price-guest') !== -1 || out.indexOf('&lt;') !== -1) {
      var tmp = document.createElement('div');
      tmp.innerHTML = out;
      out = tmp.textContent || '';
    }
    out = out.replace(/<[^>]*>/g, '').replace(/&lt;[^&]*&gt;/g, '');
    // Drop trailing `.00` / `,00` so the discount pill prices match
    // Liquid's `money_without_trailing_zeros` on the rest of the PDP.
    return out.replace(/([.,])00(?!\d)/, '');
  }

  document.addEventListener('click', function (e) {
    var copyBtn = e.target.closest('[data-dd-pill-copy]');
    if (!copyBtn) return;
    var code = copyBtn.getAttribute('data-code');
    if (!code || !navigator.clipboard || !navigator.clipboard.writeText) return;
    navigator.clipboard.writeText(code).then(function () {
      copyBtn.classList.add('is--copied');
      setTimeout(function () { copyBtn.classList.remove('is--copied'); }, 1500);
    });
  });

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible' && _currentVariant && _regiosApi) {
      var vid = String(_currentVariant.id);
      if (!_regiosDiscount || _regiosDiscount.variantId !== vid) {
        _lastApiVid = null;
        tryRegiosApiForVariant(_currentVariant);
      }
    }
  });

  setInterval(function () {
    if (!_regiosApi || !_currentVariant) return;
    var vid = String(_currentVariant.id);
    if (!_regiosDiscount || _regiosDiscount.variantId !== vid) {
      _lastApiVid = null;
      tryRegiosApiForVariant(_currentVariant);
    }
  }, 15000);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
